<template>
  <div class="filterBox">
    <div v-for="(item, index) in data" :key="index">
      <el-row class="filterBoxLine" v-if="item.html_type === 'li' && item.list.length != ''" :data-index="index"> <!-- v-if="!isArray(item['list'])" -->
        <el-col :span="2" class="alignR nowarp filterTitle">
          {{item.name}}：
        </el-col>
        <el-col :span="22">
          <ul class="filterList" :data-index="item.key">
            <li v-for="(item2, index2) in item['list']" :data-index="index2" @click="changeTag($event)" :key="index2"><span>{{item2}}</span><!-- <i>x</i> --></li>
          </ul>
        </el-col>
      </el-row>
      <el-row class="filterBoxLine" v-if="dataStatus && item.html_type === 'datetime'" style="margin-bottom:10px;" :data-index="index"> <!-- v-if="!isArray(item['list'])" -->
        <el-col :span="2" class="alignR nowarp filterTitle">
          {{item.name}}：
        </el-col>
        <el-col :span="22">
          <dates-picker v-model="date[item.key]" @input="dateChange" class="flex-basis-50"></dates-picker>
        </el-col>
      </el-row>
      <el-row class="filterBoxLine" v-if="item.html_type === 'multi_select'" :data-index="index">
        <el-col :span="2" class="alignR nowarp filterTitle">
          {{item.name}}：
        </el-col>
        <el-col :span="22">
          <div class="filterRcon">
            <div class="searchBox">
              <div>
                <el-input placeholder="搜索" @change="handleSearch(item.key)" v-model="search[item.key]" clearable></el-input>
              </div>
            </div>
            <div class="filterR" v-show="!searchStatus[item.key]">
              <div class="filterRbox" v-for="(group, indexGroup) in item.list" :key="indexGroup">
                <div class="filterRtitle" :title="group.group_name">{{group.group_name}}</div>
                <ul class="filterList" :data-index="item.key">
                  <li v-for="(item2, index2) in group['child']" :data-index="item2.event_id" :data-name="item2.event_name" @click="changeTag($event)" :key="index2"><span>{{item2.event_name}}</span></li>
                </ul>
              </div>
            </div>
            <div class="filterR" v-show="searchStatus[item.key]">
              <div class="filterRbox" v-if="group['child'] && group['child'].length > 0" v-for="(group, indexGroup) in searchList[item.key]" :key="indexGroup">
                <div class="filterRtitle" :title="group.group_name">{{group.group_name}}</div>
                <ul class="filterList" :data-index="item.key">
                  <li v-for="(item2, index2) in group['child']" :class="choseVal[item.key].indexOf(item2.event_id) > -1 ? 'cur' : ''" :data-index="item2.event_id" :data-name="item2.event_name" @click="changeTag($event)" :key="index2"><span>{{item2.event_name}}</span></li>
                </ul>
              </div>
            </div>
            <div class="filterChoose" v-if="group[item.key] && group[item.key].length > 0">
              <span>已选：</span>
              <ul>
                <li class="cur" v-if="group[item.key]" v-for="(choose, indexChoose) in group[item.key]" :key="indexChoose" @click="deleteTag(choose.event_id, item.key, indexChoose)" :data-index="choose.event_id"><span>{{choose.event_name}}</span></li>
              </ul>
              <a href="javascript:;" @click="clearTags(item.key)">清空</a>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Util from '@/common/util'
export default {
  name: 'filterTagsUser',
  props: [
    'data',
    'choseGroupList',
    'choseVal',
    'resetStatus'
  ],
  data () {
    return {
      dataStatus: false,
      date: {},
      group: {},
      search: {},
      searchList: {},
      searchStatus: {}
    }
  },
  watch: {
    'data': function () {
      this.renderData()
    },
    'resetStatus': function () {
      // console.log(document.querySelectorAll('.filterList'))
      for (let i = 0; i < document.querySelectorAll('.filterList li').length; i++) {
        document.querySelectorAll('.filterList li')[i].className = ''
      }
      this.renderData()
    },
    'date': {
      handler: function (val) {
        // console.log('val', val)
      },
      deep: true
    }
  },
  methods: {
    renderData () {
      if (this.data.length > 0) {
        this.group = {}
        this.data.map(item => {
          if (item.html_type === 'multi_select') {
            this.group[item.key] = []
            this.search[item.key] = ''
            this.searchList[item.key] = []
            this.searchStatus[item.key] = false
            item.list.map(item2 => {
              this.searchList[item.key].push({
                group_id: item2.group_id,
                group_name: item2.group_name,
                child: []
              })
            })
          } else if (item.html_type === 'datetime') {
            this.date[item.key] = []
          }
        })
        this.dataStatus = true
        // console.log(this.choseVal)
      }
    },
    dateChange (val) {
      // console.log(this.date)
      for (var key in this.date) {
        this.choseVal[key] = this.date[key]
      }
      this.$emit('changeChoice', this.choseVal)
    },
    handleSearch (key) {
      var words = this.search[key]
      if (words === '') {
        this.searchStatus[key] = false
      } else {
        this.searchStatus[key] = true
      }
      this.data.map(item => {
        if (item.html_type === 'multi_select') {
          this.searchList[item.key] = []
          item.list.map(item2 => {
            this.searchList[item.key].push({
              group_id: item2.group_id,
              group_name: item2.group_name,
              child: []
            })
          })
        }
      })
      this.data.map(item => {
        if (item.html_type === 'multi_select') {
          item.list.map((item2, index) => {
            item2.child.map(item3 => {
              if (item3.event_name.indexOf(words) > -1) {
                this.searchList[key].map(item4 => {
                  if (item4.group_id === item2.group_id) {
                    item4.child.push({
                      event_id: item3.event_id,
                      event_name: item3.event_name
                    })
                  }
                })
              }
            })
          })
        }
      })
      this.search = Object.assign({}, this.search)
    },
    deleteTag (id, key, index) {
      this.group[key].splice(index, 1)
      var allCur = document.querySelectorAll('.filterList li.cur')
      for (let i = 0; i < allCur.length; i++) {
        if (allCur[i].getAttribute('data-index') === id) {
          allCur[i].className = ''
        }
      }
      this.choseVal[key].map((item, index) => {
        if (item === id) {
          this.choseVal[key].splice(index, 1)
        }
      })
      this.$emit('changeChoice', this.choseVal)
    },
    clearTags (key) {
      var allCur = document.querySelectorAll('.filterList li.cur')
      this.group[key].map((item, index) => {
        for (let i = 0; i < allCur.length; i++) {
          if (allCur[i].getAttribute('data-index') === item.event_id) {
            allCur[i].className = ''
          }
        }
      })
      this.group[key] = []
      this.choseVal[key] = []
      this.$emit('changeChoice', this.choseVal)
    },
    changeTag (ev) {
      var curEle = ''
      var parentEle = ''
      if (ev.target.tagName === 'SPAN' || ev.target.tagName === 'I') {
        curEle = ev.path[1]
        parentEle = ev.path[2]
      } else {
        curEle = ev.target
        parentEle = ev.path[1]
      }
      // console.log(curEle.parentNode.getAttribute('data-index'))
      var keyValues = curEle.getAttribute('data-index')
      var keyGroup = parentEle.getAttribute('data-index')
      // console.log(keyValues)

      if (curEle.className && curEle.className === 'cur') {
        var allCur = document.querySelectorAll('.filterList li.cur')
        for (let i = 0; i < allCur.length; i++) {
          if (allCur[i].getAttribute('data-index') === keyValues && curEle.parentNode.getAttribute('data-index') === allCur[i].parentNode.getAttribute('data-index')) {
            allCur[i].className = ''
          }
        }
        for (var i = 0; i < this.choseVal[keyGroup].length; i++) {
          if (keyValues === this.choseVal[keyGroup][i]) {
            this.choseVal[keyGroup].splice(i, 1)
          }
        }
        // curEle.className = ''
        if (this.group[keyGroup]) {
          this.group[keyGroup].map((item, index) => {
            if (item.event_id === keyValues) {
              this.group[keyGroup].splice(index, 1)
            }
          })
          this.group = Object.assign({}, this.group)
        }
      } else {
        var allLi = document.querySelectorAll('.filterList li')
        for (let i = 0; i < allLi.length; i++) {
          if (allLi[i].getAttribute('data-index') === keyValues && curEle.parentNode.getAttribute('data-index') === allLi[i].parentNode.getAttribute('data-index')) {
            allLi[i].className = 'cur'
            // console.log(allLi[i].innerHTML)
          }
        }
        this.choseVal[keyGroup].push(keyValues)
        // curEle.className = 'cur'
        if (this.group[keyGroup]) {
          this.group[keyGroup].push({
            event_id: curEle.getAttribute('data-index'),
            event_name: curEle.getAttribute('data-name')
          })
          this.group = Object.assign({}, this.group)
        }
        // console.log(this.group)
      }
      this.$emit('changeChoice', this.choseVal)
    },
    isArray (obj) {
      return Util.isArray(obj)
    }
  },
  mounted () {
    this.renderData()
  },
  created () {
  }
}
</script>
<style scoped>
.filterBox{
  /*border-top: 1px solid #ddd;*/
  /*padding-top: 15px;*/
}
.filterTit{
  margin-bottom: 10px;
  color: #4a4a4a;
}
.filterBoxLine {
  /*border-bottom: 1px dashed #ddd;*/
  /*line-height: 50px;*/
  /*padding-bottom: 10px;*/
}
.filterList li {
  display: block;
  padding: 5px;
  border: 1px solid #fff;
  border-radius: 3px;
  line-height: 20px;
  margin-right: 5px;
  position: relative;
  cursor: pointer;
  margin-bottom: 5px;
  float: left;
}
.filterList li.cur {
  border: 1px solid rgba(64,158,255,.2);
  color: #409eff;
  background: rgba(64,158,255,.1);
}
.filterList li.cur span {
  color: #000;
}
.filterList li i{
  position: absolute;
  right: 10px;
  top: 5px;
  line-height: 20px;
  font-size: 12px;
  color: #409eff;
  font-style: normal;
  opacity: 0;
}
.filterList li.cur i{
  opacity: 1;
}
.filterList li span {
  display: block;
  /*width: 80%;*/
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  font-size: 12px;
  color: #4a4a4a;
}
.nowarp{
  /*white-space: nowrap;*/
  overflow: hidden;
  color: #4a4a4a;
}
.filterTitle {
  padding-top: 6px;
}
.filterRcon {
  border: 1px solid #eee;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 10px;
}
.filterR {
  max-height: 300px;
  overflow: hidden;
  overflow-y: scroll;
  padding: 10px;
}
.filterChoose {
  height: auto;
  overflow: hidden;
  border-top: 1px solid #ccc;
  position: relative;
}
.filterChoose > span {
  position: absolute;
  left: 10px;
  top: 10px;
}
.filterChoose > a {
  position: absolute;
  right: 20px;
  top: 10px;
  color: #409EFF;
}
.filterChoose > ul {
  margin: 5px 60px;
  display: block;
  min-height: 30px;
}
.filterChoose > ul li {
  display: block;
  padding: 5px;
  border: 1px solid #fff;
  border-radius: 3px;
  line-height: 20px;
  margin-right: 5px;
  position: relative;
  cursor: pointer;
  margin-bottom: 5px;
  float: left;
}
.filterChoose > ul li.cur {
  border: 1px solid rgba(64,158,255,.2);
  color: #409eff;
  background: rgba(64,158,255,.1);
}
.filterChoose > ul li.cur span {
  color: #000;
}
.filterChoose > ul li span {
  display: block;
  /*width: 80%;*/
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  font-size: 12px;
  color: #4a4a4a;
}
.filterRbox {
  width: 100%;
  height: auto;
  overflow: hidden;
  border-bottom: 1px solid #eee;
  position: relative;
  padding-top: 5px;
}
.filterRtitle {
  position: absolute;
  left: 0;
  top: 10px;
  width: 100px;
  overflow: hidden;
  height: 20px;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filterRbox .filterList {
  margin-left: 100px;
}
.searchBox {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.searchBox div {
  width: 300px;
  float: right;
  margin: 5px 5px 5px 0;
}
</style>
